import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

interface BannerStyleProps {
  flexibleBanner: boolean;
}

const BannerStyles = makeStyles((theme: Theme) =>
  createStyles({
    fixedHeightWrapper: {
      height: '100px',
      [theme.breakpoints.up('md')]: {
        height: '140px',
      },
      [theme.breakpoints.up('lg')]: {
        height: '200px',
      },
    },
    media: (props: BannerStyleProps) => ({
      visibility: 'visible',
      width: '100%',
      height: props.flexibleBanner ? '' : '100%',
      objectFit: props.flexibleBanner ? 'contain' : 'cover',
    }),
    hidden: {
      visibility: 'hidden',
      height: 0,
    },
  }),
);

export default BannerStyles;
